module.exports = __webpack_public_path__ + "static/media/CSU6_EDITSINGLE.7fa46bac.mp4";